import './scss/main.scss';


import { gsap } from "gsap";

import { CustomEase } from "gsap/CustomEase";
// CustomBounce requires CustomEase
import { CustomBounce } from "gsap/CustomBounce";
// CustomWiggle requires CustomEase
import { CustomWiggle } from "gsap/CustomWiggle";
import { RoughEase, ExpoScaleEase, SlowMo } from "gsap/EasePack";
    
import { Draggable } from "gsap/Draggable";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
import { Flip } from "gsap/Flip";
import { GSDevTools } from "gsap/GSDevTools";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { MotionPathHelper } from "gsap/MotionPathHelper";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { Observer } from "gsap/Observer";
import { Physics2DPlugin } from "gsap/Physics2DPlugin";
import { PhysicsPropsPlugin } from "gsap/PhysicsPropsPlugin";
import { PixiPlugin } from "gsap/PixiPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { SplitText } from "gsap/SplitText";
import { TextPlugin } from "gsap/TextPlugin";

// import gsap smoothscroll
import { ScrollSmoother } from "gsap/ScrollSmoother";


gsap.registerPlugin(Draggable,DrawSVGPlugin,EaselPlugin,Flip,GSDevTools,InertiaPlugin,MotionPathHelper,MotionPathPlugin,MorphSVGPlugin,Observer,Physics2DPlugin,PhysicsPropsPlugin,PixiPlugin,ScrollTrigger,ScrollToPlugin,SplitText,TextPlugin,RoughEase,ExpoScaleEase,SlowMo,CustomEase,CustomBounce,CustomWiggle,ScrollSmoother);

const getTriggerBounds = (el, defaultStart = "top 80%", defaultEnd = "bottom 20%") => {
  const startAttr = el?.getAttribute("data-start");
  const endAttr = el?.getAttribute("data-end");
  const stopAttr = el?.getAttribute("data-stop");
  const start = startAttr && startAttr.trim() ? startAttr.trim() : defaultStart;
  const end = endAttr && endAttr.trim() ? endAttr.trim() : (stopAttr && stopAttr.trim() ? stopAttr.trim() : defaultEnd);
  return { start, end };
};
// import Swiper
// import Swiper from 'swiper/bundle';

// // import styles bundle
// import 'swiper/css/bundle';

// import { Pagination } from 'swiper/modules';
// .. 
 jQuery(document).ready(function ($) {

  $('.category-sort-dropdown').on('change', function () {
    const form = this.form;

    if (this.value === '0') {
      window.location.href = form.dataset.shopUrl;
      return;
    }

    form.submit();
  });

  // get if user scrolls up or down
  var lastScrollTop = 0;
  $(window).scroll(function(event){
    var st = $(this).scrollTop();
    if (st > lastScrollTop){
      // downscroll code
      //console.log("downscroll");
      // add class to the header
      $("header.site-header").addClass("downscroll");
  
    } else {
      // upscroll code
      //console.log("upscroll");
      // remove class from the header
      $("header.site-header").removeClass("downscroll");

    }
    lastScrollTop = st;
  }
  );
  
     /******************************************************************************\
    	Sticky header
    \******************************************************************************/
    var scroll = $(window).scrollTop();
    var getsiteheaderheight = $("header.site-header").height();
    //console.log("The site header height is: " + getsiteheaderheight);
    if (scroll >= getsiteheaderheight) {
      $("header.site-header").addClass("sticky-header");
      $("main.site-content").addClass("sticky-header");
    }
    $(window).scroll(function() {
      scroll = $(window).scrollTop();
    
      if (scroll >= getsiteheaderheight) {
        $("header.site-header").addClass("sticky-header");
        $("main.site-content").addClass("sticky-header");
      } else {
        $("header.site-header").removeClass("sticky-header");
        $("main.site-content").removeClass("sticky-header");
      }
    });
  



	/* Toggle sub menu in mobile */
  $('.sub-menu-toggle').on('click', (e) => {

    $(e.currentTarget).parent().parent().toggleClass('is-open');
  });
  /* Toggle mobile menu */
  $('.hamburger-menu').on('click', function() {
    $('.nav-primary__mobile').toggleClass('is-open');
    $('.site-header').toggleClass('mobile-menu-open');
    $('body').toggleClass('mobile-menu-open');
  });
  

});


// gsap
// wait until DOM is ready



// GSAP SplitText integration
document.fonts.ready.then(() => {
  if (typeof gsap !== 'undefined' && typeof SplitText !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(SplitText, ScrollTrigger);
    const splitElements = gsap.utils.toArray(".split");

    splitElements.forEach((el) => {
      const dataTypeText = (el.getAttribute("data-type-text") || "").trim();
      const visibleText = (el.textContent || "").trim();
      const sourceText = visibleText || dataTypeText;

      if (!sourceText) return;

      if (!visibleText && dataTypeText) {
        el.textContent = dataTypeText;
      }

      gsap.set(el, { opacity: 1 });

      let splitTarget = el;

      // Preserve semantic heading text and animate a visual clone.
      if (/^H[1-6]$/.test(el.tagName) && !el.querySelector('.split-text')) {
        const seoText = document.createElement('span');
        seoText.textContent = sourceText;
        seoText.style.position = 'absolute';
        seoText.style.width = '1px';
        seoText.style.height = '1px';
        seoText.style.padding = '0';
        seoText.style.margin = '-1px';
        seoText.style.overflow = 'hidden';
        seoText.style.clip = 'rect(0, 0, 0, 0)';
        seoText.style.whiteSpace = 'nowrap';
        seoText.style.border = '0';

        const visualText = document.createElement('span');
        visualText.className = 'split-text';
        visualText.setAttribute('aria-hidden', 'true');
        visualText.textContent = sourceText;

        el.textContent = '';
        if (!el.hasAttribute('aria-label')) {
          el.setAttribute('aria-label', sourceText);
        }

        el.appendChild(seoText);
        el.appendChild(visualText);
        splitTarget = visualText;
      }

      SplitText.create(splitTarget, {
        type: "words,lines",
        linesClass: "line",
        autoSplit: true,
        mask: "lines",
        onSplit: (self) => {
          const { start: splitStart, end: splitEnd } = getTriggerBounds(el, "top 80%", "bottom 20%");
          gsap.from(self.lines, {
            duration: 1.6,
            yPercent: 100,
            opacity: 0,
            stagger: 0.1,
            ease: "expo.out",
            scrollTrigger: {
              trigger: el,
              start: splitStart,
              end: splitEnd,
              toggleActions: "play reverse play reverse",
              once: false
            }
          });
        }
      });
    });
    
  } else {
    console.warn('GSAP, SplitText, or ScrollTrigger not loaded');
  }
}
);

    // BEGIN: GSAP SplitText animation for .my-split on scroll (smoother, triggers near middle)
    if (typeof gsap !== 'undefined' && typeof SplitText !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(SplitText, ScrollTrigger);

      document.querySelectorAll('.my-split').forEach((el) => {
        const parseNumAttr = (value) => {
          if (value === null || value === undefined || value === '') return NaN;
          return Number(String(value).trim().replace(',', '.'));
        };

        const decodeEntities = (value) => {
          const parser = document.createElement('textarea');
          parser.innerHTML = value;
          return parser.value;
        };

        const htmlToText = (value) => {
          const parser = document.createElement('div');
          parser.innerHTML = value;
          return (parser.textContent || '').trim();
        };

        const dataTypeHtmlRaw = (el.getAttribute('data-type-html') || '').trim();
        const dataTypeHtml = dataTypeHtmlRaw ? decodeEntities(dataTypeHtmlRaw) : '';
        const dataTypeText = (el.getAttribute('data-type-text') || '').trim();

        gsap.set(el, { opacity: 1 });
        let splitTarget = el.querySelector('.my-split-text');

        if (!splitTarget && dataTypeHtml && !/^H[1-6]$/.test(el.tagName)) {
          el.innerHTML = dataTypeHtml;
        }

        // Keep semantic heading text available for crawlers/a11y and animate a visual clone.
        if (!splitTarget && /^H[1-6]$/.test(el.tagName)) {
          const originalHtml = dataTypeHtml || (el.innerHTML || '').trim();
          const originalText = el.textContent.trim() || dataTypeText || htmlToText(originalHtml);

          if (!originalText && !originalHtml) return;

          if (!el.textContent.trim() && dataTypeText) {
            el.textContent = dataTypeText;
          }

          const seoText = document.createElement('span');
          seoText.textContent = originalText;
          seoText.style.position = 'absolute';
          seoText.style.width = '1px';
          seoText.style.height = '1px';
          seoText.style.padding = '0';
          seoText.style.margin = '-1px';
          seoText.style.overflow = 'hidden';
          seoText.style.clip = 'rect(0, 0, 0, 0)';
          seoText.style.whiteSpace = 'nowrap';
          seoText.style.border = '0';

          splitTarget = document.createElement('span');
          splitTarget.className = 'my-split-text';
          splitTarget.setAttribute('aria-hidden', 'true');
          splitTarget.innerHTML = originalHtml || originalText;

          el.textContent = '';
          if (!el.hasAttribute('aria-label')) {
            el.setAttribute('aria-label', originalText);
          }
          el.appendChild(seoText);
          el.appendChild(splitTarget);
        }

        splitTarget = splitTarget || el;
        const splitDelay = parseNumAttr(el.getAttribute('data-delay')); 
  const { start: splitStart, end: splitEnd } = getTriggerBounds(el, 'top 60%', 'bottom 20%');
        gsap.set(splitTarget, { opacity: 1 });
        const hasLinks = !!splitTarget.querySelector('a');
        const splitType = hasLinks ? 'lines' : 'words,lines';

        SplitText.create(splitTarget, {
          type: splitType,
          tag: 'span',
          linesClass: 'line',
          autoSplit: true,
          mask: 'lines', 
          onSplit: (self) => {
            gsap.from(self.lines, {
              duration: 1.35,
              delay: Number.isFinite(splitDelay) ? splitDelay : 0,
              yPercent: 90,
              opacity: 0,
              stagger: 0.1,
              ease: 'sine.out',
              scrollTrigger: {
                trigger: el,
                start: splitStart,
                end: splitEnd,
                toggleActions: 'play reverse play reverse',
                once: false
              }
            });
          }
        });
      });
    } else {
      console.warn('GSAP, SplitText, or ScrollTrigger not loaded');
    }
// END: GSAP SplitText animation for .my-split on scroll (smoother, triggers near middle)

// new scrollsplit
gsap.registerPlugin(SplitText, ScrollTrigger);

document.fonts.ready.then(() => {
  let containers = gsap.utils.toArray(".scrolled-split-element");

  containers.forEach((container) => {
    let text = container.querySelector(".scrolled-split");
    if (!text) return;
    SplitText.create(text, {
      type: "words,lines",
      mask: "lines",
      linesClass: "line",
      autoSplit: true,
      onSplit: (instance) => {
        return gsap.from(instance.lines, {
          yPercent: 120,
          duration: 2.2,
          ease: "power2.out",
          stagger: 0.18,
          scrollTrigger: {
            trigger: container,
            scrub: true,
            start: "clamp(top center)",
            end: "clamp(bottom center)"
          }
        });
      }
    });
  });
});

// Reusable GSAP animation system based on classes
document.addEventListener("DOMContentLoaded", function() {
  // Ensure GSAP and ScrollTrigger are available
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    const animationMap = {
      "fade-in": { opacity: 1, y: 0, duration: 2, ease: "power2.out" },
      "slide-up": { y: 0, opacity: 1, duration: 1.2, ease: "expo.out" },
      "bounce-in": { y: 0, opacity: 1, duration: 1.5, ease: "bounce.out" },
      "rotate-in": { rotation: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "scale-in": { scale: 1, opacity: 1, duration: 1.1, ease: "back.out(1.7)" },
      "flip-in": { rotationY: 0, opacity: 1, duration: 1.3, ease: "power2.out" },
      "slide-left": { x: 0, opacity: 1, duration: 1.2, ease: "expo.out" },
      "slide-right": { x: 0, opacity: 1, duration: 1.2, ease: "expo.out" },
      "elastic-in": { y: 0, opacity: 1, duration: 1.6, ease: "elastic.out(1, 0.3)" },
      "fade-scale-in": { scale: 1, opacity: 1, duration: 1.2, ease: "power1.out" },
      "zoom-in": { scale: 1, opacity: 1, duration: 1.4, ease: "expo.out" },
      "skew-in": { skewY: 0, opacity: 1, duration: 1.1, ease: "power2.out" },
      "slide-down": { y: 0, opacity: 1, duration: 1.2, ease: "expo.out" },
      "flip-x-in": { rotationX: 0, opacity: 1, duration: 1.3, ease: "power2.out" },
      "fade-up": { y: 0, opacity: 1, duration: 1.1, ease: "power1.out" },
      "fade-down": { y: 0, opacity: 1, duration: 1.1, ease: "power1.out" },
      "fade-left": { x: 0, opacity: 1, duration: 1.1, ease: "power1.out" },
      "fade-right": { x: 0, opacity: 1, duration: 1.1, ease: "power1.out" },
      "pop-in": { scale: 1, opacity: 1, duration: 1.2, ease: "back.out(2)" },
      "rotate-pop-in": { rotation: 0, scale: 1, opacity: 1, duration: 1.3, ease: "back.out(2)" },
      "fade-in-from-top-right": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "fade-in-from-top-left": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "fade-in-from-bottom-right": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "fade-in-from-bottom-left": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "slide-in-from-top-left": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "slide-in-from-top-right": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "slide-in-from-bottom-left": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "slide-in-from-bottom-right": { x: 0, y: 0, opacity: 1, duration: 1.2, ease: "power2.out" },
      "type-in": { text: (i, target) => target.getAttribute("data-type-text") || target.textContent.trim(), duration: 2.5, ease: "none" }
    };

    Object.entries(animationMap).forEach(([className, animProps]) => {
      document.querySelectorAll(`.${className}`).forEach((el) => {
        // Prevent double initialization
        if (el.dataset.gsapAnimated) return;
        el.dataset.gsapAnimated = "true";
        // Set initial state
        let fromVars = {};
        if (className === "fade-in") fromVars = { opacity: 0, y: 30 };
        else if (className === "slide-up") fromVars = { opacity: 0, y: 100 };
        else if (className === "bounce-in") fromVars = { opacity: 0, y: 100 };
        else if (className === "rotate-in") fromVars = { opacity: 0, rotation: -90 };
        else if (className === "scale-in") fromVars = { opacity: 0, scale: 0.5 };
        else if (className === "flip-in") fromVars = { opacity: 0, rotationY: 90 };
        else if (className === "slide-left") fromVars = { opacity: 0, x: 100 };
        else if (className === "slide-right") fromVars = { opacity: 0, x: -100 };
        else if (className === "elastic-in") fromVars = { opacity: 0, y: 80 };
        else if (className === "fade-scale-in") fromVars = { opacity: 0, scale: 0.8 };
        else if (className === "zoom-in") fromVars = { opacity: 0, scale: 0.3 };
        else if (className === "skew-in") fromVars = { opacity: 0, skewY: 20 };
        else if (className === "slide-down") fromVars = { opacity: 0, y: -100 };
        else if (className === "flip-x-in") fromVars = { opacity: 0, rotationX: 90 };
        else if (className === "fade-up") fromVars = { opacity: 0, y: 40 };
        else if (className === "fade-down") fromVars = { opacity: 0, y: -40 };
        else if (className === "fade-left") fromVars = { opacity: 0, x: 40 };
        else if (className === "fade-right") fromVars = { opacity: 0, x: -40 };
        else if (className === "pop-in") fromVars = { opacity: 0, scale: 0.7 };
        else if (className === "rotate-pop-in") fromVars = { opacity: 0, rotation: 45, scale: 0.7 };
        else if (className === "fade-in-from-top-right") fromVars = { opacity: 0, x: 30, y: -30 };
        else if (className === "fade-in-from-top-left") fromVars = { opacity: 0, x: -30, y: -30 };
        else if (className === "fade-in-from-bottom-right") fromVars = { opacity: 0, x: 30, y: 30 };
        else if (className === "fade-in-from-bottom-left") fromVars = { opacity: 0, x: -30, y: 30 };
        else if (className === "slide-in-from-top-left") fromVars = { opacity: 0, x: -100, y: -100 };
        else if (className === "slide-in-from-top-right") fromVars = { opacity: 0, x: 100, y: -100 };
        else if (className === "slide-in-from-bottom-left") fromVars = { opacity: 0, x: -100, y: 100 };
        else if (className === "slide-in-from-bottom-right") fromVars = { opacity: 0, x: 100, y: 100 }; 
          else if (className === "type-in") fromVars = { opacity: 1, text: "" };
        gsap.set(el, fromVars);
        // Allow per-element overrides via data attributes
        const overrideProps = {};
        // List of animatable GSAP properties you want to allow as overrides
        [
          'duration', 'ease', 'opacity', 'x', 'y', 'scale', 'rotation', 'rotationX', 'rotationY', 'skewY', 'stagger', 'delay'
        ].forEach((prop) => {
          const attr = el.getAttribute('data-' + prop.toLowerCase());
          if (attr !== null && attr !== undefined && attr !== "") {
            // Convert to number if appropriate
            if (!isNaN(attr) && prop !== 'ease') {
              overrideProps[prop] = Number(attr);
            } else {
              overrideProps[prop] = attr;
            }
          }
        });

        const { start, end } = getTriggerBounds(el, 'top 80%', 'bottom 20%');
        const scrollTriggerConfig = {
          trigger: el,
          start,
          end,
          toggleActions: "play reverse play reverse"
        };

        gsap.to(el, {
          ...animProps,
          ...overrideProps,
          ...(el.dataset.trigger === 'load' ? {} : { scrollTrigger: scrollTriggerConfig })
        });
      });
    });
  } else {
    console.warn('GSAP or ScrollTrigger not loaded');
  }
});

// document.addEventListener("DOMContentLoaded", function() {
//   gsap.to(".fade-in", {opacity: 1, duration: 2});
// });

// create staggert text reveal when scroll a word fades in 

gsap.registerPlugin(ScrollTrigger);

document.fonts.ready.then(() => {
  let containers = gsap.utils.toArray(".staggered-text-container");

  containers.forEach((container) => {
    let text = container.querySelector(".staggered-text");
    if (!text) return;
    SplitText.create(text, {
      type: "words",
      mask: "words",
      wordsClass: "word",
      autoSplit: true,
      onSplit: (instance) => {
        // User controls initial and animated styles via classes:
        // .staggered-text-initial (initial state), .staggered-text-animated (after animation)
        // All words visible initially
        instance.words.forEach(word => {
          word.classList.add('staggered-text-initial');
          word.classList.remove('staggered-text-animated');
          // word.style.opacity = '0.1'; // Start faded
          word.style.transform = 'none'; // Ensure no yPercent transform
        });
        return gsap.to(
          instance.words,
          {
            // opacity: 1, // Animate to fully visible
            stagger: {
              each: 0.25, // Slower stagger per word
              ease: "power2.out",
              amount: 1.5 // Spread stagger over a longer scroll
            },
            duration: 0.8,
            scrollTrigger: {
              trigger: container,
              start: "top 72%", // Start a bit later
              end: "bottom 40%", // End further down for slower reveal
              scrub: 1, // Make the staggered animation tied to scroll
              markers: false,
              onUpdate: self => {
                // Toggle classes based on progress for each word
                const progress = self.progress;
                instance.words.forEach((word, i) => {
                  // Calculate when this word should be considered animated
                  const wordProgress = (i + 1) / instance.words.length;
                  if (progress >= wordProgress) {
                    word.classList.add('staggered-text-animated');
                    word.classList.remove('staggered-text-initial');
                  } else {
                    word.classList.add('staggered-text-initial');
                    word.classList.remove('staggered-text-animated');
                  }
                });
              },
              onReverseComplete: () => {
                instance.words.forEach(word => {
                  word.classList.add('staggered-text-initial');
                  word.classList.remove('staggered-text-animated');
                  // word.style.opacity = '0.1'; // Reset to faded
                });
              }
            }
          }
        );
      }
    });
  });
}); 


// add smooth scolling on entire page with these classes .mysmooth-content .the-smoothcontent


// Example: stagger animation for children of .fade-in.demo-block[data-stagger]

// rotating anna



// section dive
gsap.registerPlugin(ScrollTrigger);

var panels = gsap.utils.toArray(".main-hero-section");
var firstPanel = panels[0];

if (firstPanel) {
  gsap.set(firstPanel, {
    transformOrigin: "50% 0%",
    force3D: true
  });

  gsap.fromTo(firstPanel,
    {
      yPercent: 0,
      rotationX: 0,
      z: 0,
      scale: 1,
      opacity: 1,
      filter: "blur(0px)"
    },
    {
      yPercent: -8,
      rotationX: 0,
      z: -100,
      scale:1,
      opacity:0,
      filter: "blur(0px)", 
      ease: "sine.inOut",
      scrollTrigger: {
        trigger: firstPanel,
        start: "top top",
        end: "bottom top",
        scrub: true
      }
    }
  );
}

const heroBgImages = gsap.utils.toArray(".main-hero-image img");

heroBgImages.forEach((img) => {
  gsap.set(img, { willChange: "transform, filter", force3D: true });

  gsap.fromTo(
    img,
    {
      scale: 1,
      yPercent: 0,
      filter: "blur(0px)"
    },
    {
      scale: 1.3,
      yPercent:0,
      filter: "blur(1.5px)",
      ease: "none",
      scrollTrigger: {
        trigger: firstPanel || img,
        start: "top top",
        end: "bottom top",
        scrub: true
      }
    }
  );
});




// text reveal
document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined") return;

  document.querySelectorAll(".reveal").forEach((el) => {
    const spans = el.querySelectorAll("span");
    if (!spans.length) return;

    const parseNumAttr = (value) => {
      if (value === null || value === undefined || value === "") return NaN;
      return Number(String(value).trim().replace(",", "."));
    };

    const firstSpan = spans[0];

    const durationAttr = parseNumAttr(el.getAttribute("data-duration"));
    const delayAttr = parseNumAttr(el.getAttribute("data-delay"));
    const yAttr = parseNumAttr(el.getAttribute("data-y"));
    const skewYAttr = parseNumAttr(el.getAttribute("data-skewy"));
    const staggerAmountAttr = parseNumAttr(el.getAttribute("data-stagger-amount"));
    
    const easeAttr = el.getAttribute("data-ease");

    const spanDelayAttr = parseNumAttr(firstSpan?.getAttribute("data-delay"));
    const effectiveDelay = Number.isFinite(delayAttr)
      ? delayAttr
      : (Number.isFinite(spanDelayAttr) ? spanDelayAttr : 1);

    gsap.from(spans, {
      y: Number.isFinite(yAttr) ? yAttr : 100,
      ease: easeAttr || "power4.out",
      delay: effectiveDelay,
      skewY: Number.isFinite(skewYAttr) ? skewYAttr : 7,
      duration: Number.isFinite(durationAttr) && durationAttr > 0 ? durationAttr : 1.8,
      stagger: {
        amount: Number.isFinite(staggerAmountAttr) ? staggerAmountAttr : 0.3
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  const typeStart = isMobile ? "top 96%" : "top 80%";

  document.querySelectorAll(".type-text").forEach((el) => {
    const text = el.getAttribute("data-type-text") || el.textContent.trim();
    const duration = Number(el.getAttribute("data-duration")) || 2.5;
    const { start, end } = getTriggerBounds(el, typeStart, "bottom 20%");

    el.textContent = "";

    gsap.to(el, {
      text,
      duration,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        start,
        end,
        toggleActions: "play reverse play reverse"
      }
    });
  });
});

// shifting colors
gsap.registerPlugin(ScrollTrigger);

const sections = gsap.utils.toArray(".colorfade-section");

const ensureGradientOverlay = (target) => {
  if (!target) return null;
  target.classList.add("colorfade-gradient-ready");
  return target;
};

const getGradientFallbackColor = (gradient, explicitColor, fallbackColor) => {
  if (explicitColor) return explicitColor;
  if (!gradient || typeof gradient !== "string") return fallbackColor;

  const tokenRegex = /#(?:[0-9a-fA-F]{3,8})\b|rgba?\([^\)]+\)|hsla?\([^\)]+\)/;
  const match = gradient.match(tokenRegex);
  return match ? match[0] : fallbackColor;
};

const switchColor = (target, color) => {
  if (!target || !color) return;

  const overlayTarget = ensureGradientOverlay(target);
  if (!overlayTarget) return;

  overlayTarget.style.setProperty(
    "--colorfade-overlay-image",
    "linear-gradient(180deg, var(--colorfade-overlay-solid) 0%, var(--colorfade-overlay-solid) 100%)"
  );

  gsap.to(overlayTarget, {
    duration: 0.7,
    ease: "sine.inOut",
    "--colorfade-overlay-solid": color,
    "--colorfade-overlay-opacity": 1,
    overwrite: "auto"
  });
};

const switchGradient = (target, gradient, baseColor) => {
  if (!target || !gradient) return;

  const gradientTarget = ensureGradientOverlay(target);
  if (!gradientTarget) return;

  if (baseColor) {
    gradientTarget.style.setProperty("--colorfade-overlay-solid", baseColor);
  }

  gradientTarget.style.setProperty("--colorfade-overlay-image", gradient);

  gsap.to(gradientTarget, {
    duration: 0.7,
    ease: "sine.inOut",
    "--colorfade-overlay-opacity": 1,
    overwrite: "auto"
  });
};

sections.forEach((section, i) => {
  const color = section.dataset.bgcolor;
  const gradient = section.dataset.bggradient;
  const originalColor = window.getComputedStyle(section).backgroundColor;
  const gradientBaseColor = getGradientFallbackColor(gradient, color, originalColor);

  if (!color && !gradient) return;

  ScrollTrigger.create({
    trigger: section,
    start: "top 60%",
    end: "bottom center",
    onEnter: () => (gradient ? switchGradient(section, gradient, gradientBaseColor) : switchColor(section, color)),
    onEnterBack: () => (gradient ? switchGradient(section, gradient, gradientBaseColor) : switchColor(section, color)),
    onLeaveBack: () => switchColor(section, originalColor)
    // markers: { indent: 150 * i },
    // id: i + 1
  });
});

// image effect
gsap.registerPlugin(ScrollTrigger);

if (document.querySelector(".mysmooth-content .the-smoothcontent")) {
  gsap.utils.toArray(".mysmooth-content .the-smoothcontent img").forEach((img) => {
    const triggerEl = img.closest(".image_cont") || img;

    gsap.fromTo(img,
      {
        yPercent: -15,
        scale: 1
      },
      {
        yPercent: 35,
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: triggerEl,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.35
        }
      }
    );
  });
}


// blur out when scrolling away down from the element so its not blurred when scrolling up but blurred when scroll a very bit down.still in view but blurred then when scroll up it should be clear again
gsap.registerPlugin(ScrollTrigger);

gsap.utils.toArray(".blur-on-scroll").forEach((el) => {
  const minScrollPx = 60;
  const setSharp = () => gsap.to(el, { filter: "blur(0px)", ease: "sine.out", duration: 0.25, overwrite: "auto" });
  const setBlurred = () => gsap.to(el, { filter: "blur(5px)", ease: "sine.out", duration: 0.35, overwrite: "auto" });

  // Always start clear and only blur after scrolling a little bit down.
  gsap.set(el, { filter: "blur(0px)" });

  ScrollTrigger.create({
    trigger: el,
    start: "top bottom",
    end: "bottom top",
    onRefreshInit: () => gsap.set(el, { filter: "blur(0px)" }),
    onEnterBack: setSharp,
    onLeaveBack: setSharp,
    onUpdate: (self) => {
      const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (scrollY <= minScrollPx) {
        gsap.set(el, { filter: "blur(0px)" });
        return;
      }

      if (self.direction === 1 && self.progress > 0.16) {
        setBlurred();
      } else if (self.direction === -1 || self.progress <= 0.16) {
        setSharp();
      }
    },
    markers: false
  });
});

// add gsap smoothscroll
if (document.querySelector("#smooth-wrapper")) {
  ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    smooth: 0.6,
    speed: 0.85,
    effects: false,
    normalizeScroll: false,
    smoothTouch: 0,
    wholePixels: true,
    ignoreMobileResize: true
  });
}

// smooth cinematic parallax for the third section image
if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);

  const img = document.querySelector(".third-main-container .the-paralax-image img");
  const section = document.querySelector(".third-main-container");

  if (img && section) {
    // Respect reduced motion
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReduced) {
      gsap.set(img, { clearProps: "transform,filter" });
    } else {
      gsap.fromTo(
        img,
        {
          yPercent: -6,
          scale: 1.08,
          filter: "blur(0px)"
        },
        {
          yPercent: 6,
          scale: 1.18,
          filter: "blur(1px)",
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: 0.8
          }
        }
      );
    }
  }
}

// scroll photos into place together
const photoGrids = gsap.utils.toArray(".the-photo-container .the-image-grid");

photoGrids.forEach((photosTrigger) => {
  const photos = gsap.utils.toArray(".photo", photosTrigger);

  if (photos.length) {
    const { start, end } = getTriggerBounds(photosTrigger, "top 92%", "top 40%");

    photos.forEach((photo, index) => {
      const yStart = Number(photo.getAttribute("data-y-start"));
      const fallbackStart = index === 0 ? 20 : 30;
      const safeYStart = Number.isFinite(yStart) ? yStart : fallbackStart;

      gsap.fromTo(
        photo,
        {
          yPercent: safeYStart,
          force3D: true
        },
        {
          yPercent: 0,
          ease: "none",
          overwrite: "auto",
          scrollTrigger: {
            trigger: photosTrigger,
            start,
            end,
            scrub: 1,
            invalidateOnRefresh: true,
            markers: false
          }
        }
      );
    });
  }
});